import React, { useState } from "react";
import { TextField, Grid, Typography, Box } from "@mui/material";


const arrValues = [
    { label: 'Brinco', field: 'brinco' },
    { label: 'Correntaria', field: 'correntaria' },
    { label: 'Bracelete/Anel', field: 'bracelete_anel' },
    { label: 'Ródio B', field: 'rodio_b' },
    { label: 'Ródio N', field: 'rodio_n' },
]
const DecimalInputGrid = (props) => {
    const { valuesForm, setValuesForm, lockInput } = props

    const handleChange = (e) => {
        let { name, value } = e.target;

        // Replace dots with commas for display
        value = value.replace(".", ",");

        // Ensure only valid decimal input (Brazilian format)
        if (/^\d*(,\d*)?$/.test(value) || value === "") {
            setValuesForm((prev) => ({ ...prev, [name]: value }));
        }
    };

    return (
        // <Box
        // sx={{
        //     display: 'flex',
        //     flexDirection: 'column',
        //     gap: '30px',
        //     marginTop: '-50px'
        // }}
        // >
        //     <Box sx={{marginLeft: '-10px'}}>
        //         <Typography>Ajustes dos preços</Typography>
        //     </Box>
        <Grid container spacing={2} sx={{ display: "flex", gap: "40px" }}>

            {arrValues.map((data) => (
                <TextField
                    disabled={lockInput}
                    key={data.field}
                    name={data.field}
                    label={data.label}
                    variant="outlined"
                    value={valuesForm[data.field]}
                    onChange={handleChange}
                    sx={{
                        width: "120px",
                        backgroundColor: lockInput && 'rgba(239, 239, 240,0.2)',
                        "& .MuiOutlinedInput-root": {
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "white", // Keeps border white on hover
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "white", // Keeps border white when focused
                            }
                        },
                        "& .MuiInputLabel-root": {
                            color: "white", // Keeps label white
                            "&.Mui-focused": {
                                color: "white", // Keeps label white when focused
                            }
                        }
                    }}
                    inputProps={{
                        inputMode: "decimal",
                        pattern: "[0-9]+([,][0-9]*)?"  // Accepts only Brazilian decimal format
                    }}
                />
            ))}
        </Grid>
        // </Box>
    );
};

export default DecimalInputGrid;